/* tslint:disable */
/* eslint-disable */
/**
 * 3DSurvey API
 * Frontend API for 3d Survey
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Survey } from './Survey';
import {
    SurveyFromJSON,
    SurveyFromJSONTyped,
    SurveyToJSON,
} from './Survey';

/**
 * 
 * @export
 * @interface GetProjectSurvey200Response
 */
export interface GetProjectSurvey200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetProjectSurvey200Response
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetProjectSurvey200Response
     */
    error: string;
    /**
     * 
     * @type {Array<Survey>}
     * @memberof GetProjectSurvey200Response
     */
    data: Array<Survey>;
}

/**
 * Check if a given object implements the GetProjectSurvey200Response interface.
 */
export function instanceOfGetProjectSurvey200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "success" in value;
    isInstance = isInstance && "error" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function GetProjectSurvey200ResponseFromJSON(json: any): GetProjectSurvey200Response {
    return GetProjectSurvey200ResponseFromJSONTyped(json, false);
}

export function GetProjectSurvey200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProjectSurvey200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': json['success'],
        'error': json['error'],
        'data': ((json['data'] as Array<any>).map(SurveyFromJSON)),
    };
}

export function GetProjectSurvey200ResponseToJSON(value?: GetProjectSurvey200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
        'error': value.error,
        'data': ((value.data as Array<any>).map(SurveyToJSON)),
    };
}

